export default __webpack_public_path__ + "static/media/footer-logo.8e92718a.svg";